import { o as objectIsPrototypeOf } from '../../internals/object-is-prototype-of.js';
import { b as bind$1 } from '../function/virtual/bind.js';

var isPrototypeOf = objectIsPrototypeOf;
var method = bind$1;

var FunctionPrototype = Function.prototype;

var bind = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (isPrototypeOf(FunctionPrototype, it) && own === FunctionPrototype.bind) ? method : own;
};

export { bind as b };
//# sourceMappingURL=bind.js.map
